export default __webpack_public_path__ + "static/coperta-retete-b1b439a7ddb4cea26ce8bc255685f1d4.jpg";